import { autorun } from 'mobx'
import { store } from './../store'

export default class PoolHeader extends HTMLElement {
  _active = false
  _menuColor = 'black'
  disposer

  set active(state: boolean) {
    this._active = state

    // this.update('active', state)
  }

  get active() {
    return this._active
  }

  set menu(color: string) {
    this._menuColor = color

    // this.update('menu', color)
  }

  get menu() {
    return this._menuColor
  }

  update() {
    // update required attributes and class names once toggled

    // this.className = ''
  }

  constructor() {
    super()

    this.disposer = autorun(() => {
      this.active = store.active

      this.menu = store.menu
    })

    this.className = 'bg-white flex items-center px-5 py-5 w-full fixed top-0 left-0 z-50'
  }
  
  connectedCallback() {
  }

  disconnectedCallback() {
    this.disposer()
  }
}

customElements.define('pool-header', PoolHeader)
